import axios from 'axios';

const API_URL = 'https://api.protektor-polska.pl:5000/api/auth/';  //http://85.255.5.121:5000/api/auth/ //http://localhost:5000/api/auth/ //https://api.protektor-polska.pl:5000/api/auth/

class AuthService {
  login(user) {
    return axios
      .post(API_URL + 'signin', {
        username: user.username,
        password: user.password
      })
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }

        return response.data;
      });
  }

  logout() {
    localStorage.removeItem('user');
  }

  register(user) {
    return axios.post(API_URL + 'signup', {
      username: user.username,
      email: user.email,
      password: user.password
    });
  }
}

export default new AuthService();